module.exports = __webpack_public_path__ + "img/logo.4fa40ff7.png";